import type {
  CampaignLeaderboardRequest,
  DynamicCampaign,
  DynamicCampaignSummary,
  ProfileLeaderboard,
  UserData,
} from '../../types';

import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getAllDynamicCampaign,
  getCampaignLeaderboard,
  getDynamicCampaign,
  getUserData,
} from '../../api/campaign';
import { getErrorMessage } from '../../utils/Errors';

export const fetchUserData = createAsyncThunk<
  UserData | null,
  { id: string },
  { rejectValue: string | null }
>('campaign/fetchUserData', async (params, thunkApi) => {
  try {
    const userData = await getUserData(params.id, thunkApi.signal);
    return userData.data;
  } catch (error) {
    return thunkApi.rejectWithValue(getErrorMessage(error));
  }
});

export const fetchCampaignLeaderboard = createAsyncThunk<
  {
    leaderboard: ProfileLeaderboard[] | null;
    totalPages: number | null;
  },
  CampaignLeaderboardRequest,
  { rejectValue: string }
>('profile/fetchCampaignLeaderboard', async (params, thunkApi) => {
  try {
    const leaderboard = await getCampaignLeaderboard(params, thunkApi.signal);
    return { leaderboard: leaderboard.data, totalPages: leaderboard.totalPages };
  } catch (error) {
    return thunkApi.rejectWithValue(getErrorMessage(error));
  }
});

export const fetchDynamicCampaign = createAsyncThunk<
  DynamicCampaign | null,
  { id: string },
  { rejectValue: string | null }
>('campaign/fetchDynamicCampaign', async (params, thunkApi) => {
  try {
    const dynamicCampaign = await getDynamicCampaign(params.id, thunkApi.signal);
    return dynamicCampaign;
  } catch (error) {
    return thunkApi.rejectWithValue(getErrorMessage(error));
  }
});

export const fetchAllDynamicCampaign = createAsyncThunk<
  DynamicCampaignSummary[] | null,
  undefined,
  { rejectValue: string | null }
>('campaign/fetchAllDynamicCampaign', async (_, thunkApi) => {
  try {
    const dynamicCampaigns = await getAllDynamicCampaign(thunkApi.signal);
    return dynamicCampaigns;
  } catch (error) {
    return thunkApi.rejectWithValue(getErrorMessage(error));
  }
});
